import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchSubscriptionPayment, createSubscriptionPayment } from "./thunks";
import { toast } from "react-toastify";

interface SubscriptionPaymentState {
  clientSubscription: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: SubscriptionPaymentState = {
  clientSubscription: null,
  loading: false,
  error: null,
};

const paymentSubscriptionSlice = createSlice({
  name: "subscriptionPayments",
  initialState,
  reducers: {
    clearSubscriptionPayment: (state) => {
      state.clientSubscription = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchSubscriptionPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchSubscriptionPayment.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.clientSubscription = action.payload.data;
        },
      )
      .addCase(fetchSubscriptionPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as { error: string }).error;
        toast.error("Erro ao buscar dados da assinatura");
      })

      // CREATE
      .addCase(createSubscriptionPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createSubscriptionPayment.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          toast.success("Pagamento criado com sucesso!");
        },
      )
      .addCase(createSubscriptionPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as { error: string }).error;
        toast.error("Erro ao criar pagamento");
      });
  },
});

export const { clearSubscriptionPayment } = paymentSubscriptionSlice.actions;
export default paymentSubscriptionSlice.reducer;
